import React, { Component } from 'react';
import './KPIHistory.css';
import { Line } from 'react-chartjs-2';
import { format_date, getKPIColors, KPI_color, KPI_route_name } from '../../_utils/kpi';
import { push_history } from '@acri-tools/react-tools/utils/global';


interface Props {
    // data: {
    //     [key:string]:Array<any>
    // }
    months: Array<string>
    kpi_definitions: any
    kpis: any
    kpi_performance_levels: any
}
interface State{
    loading?: boolean
}


export default class KPIHistory extends Component<Props, State>{
    constructor(props:Props){
        super(props);
    }

    render() {
        let { kpis, kpi_definitions } = this.props;
        let headers = kpi_definitions?.map((d:any, key:number)=>{
            return d.name
        })
        let reverse_months = [...this.props.months].reverse();
        // let reverse_months = [...this.props.months].reverse();
        // console.log("reversed_data_keys",reversed_data_keys)
        return (
            <div className="kpi-history">
                {/* GRAPH */}
                <div className="kpi-history-graph">
                    <Line
                        options={{
                            responsive: true,
                            maintainAspectRatio: false,
                            scales:{
                                yAxes: [{
                                    ticks:{
                                        min: 0,
                                        max: 100
                                    }
                                }]
                            },
                            elements: {
                                line: {
                                    tension: 0 // disables bezier curves
                                }
                            },
                        }}
                        data={{
                            labels: reverse_months,
                            datasets: headers?.map((kpi_name: string, idx:number)=>{
                                return {
                                    label: kpi_name,
                                    backgroundColor: KPI_color(idx),
                                    borderColor: KPI_color(idx, true),
                                    fill:false,
                                    data: reverse_months.map((key:string)=>{
                                        // list of monthly data

                                        let kpi = kpis[key]?.find((kpi_data:any) => kpi_data?.kpi_definition === kpi_name );
                                        if (!kpi) return null;
                                        let is_percentage = 'percentage' in kpi.value
                                        let value = is_percentage ? kpi?.value.percentage : kpi?.value.value
                                        return value;
                                    })
                                }
                            })
                        }}
                    />
                </div>
                {/* LIST */}
                <table>
                    <tbody>
                        <tr>
                            <th>Date</th>
                            {
                                headers?.map((header: string, key:number)=>(
                                    <th key={key} >
                                        <span onClick={()=>{ push_history(`/kpis/${KPI_route_name(header)}`) }}>
                                            { header }
                                        </span>
                                    </th>
                                ))
                            }
                        </tr>
                        {
                            reverse_months?.map((month:string, key:number)=>(
                                <tr key={key}>
                                    <td>{format_date(month)}</td>
                                    {
                                        this.props.kpi_definitions?.map((kpi_definition:any, key2:number)=>{
                                            let kpi = this.props.kpis[month]?.[kpi_definition.id - 1];
                                            let is_percentage = kpi && 'percentage' in kpi.value
                                            let colors = getKPIColors(kpi?.level);
                                            let value = !kpi ? '-' :
                                                is_percentage ? kpi?.value.percentage : kpi?.value.value
                                            return(
                                                <td
                                                    key={key2}
                                                >
                                                    <div className="kpi-history-value">
                                                        {value}{is_percentage ? '%' : ''}{" "}
                                                        {
                                                            kpi?.level &&
                                                            <span
                                                                style={{
                                                                    color: colors ? colors[1] : undefined
                                                                }}
                                                            >
                                                                (Lvl.{kpi.level})
                                                            </span>
                                                        }
                                                    </div>
                                                </td>
                                            )
                                        })
                                        // this.props.kpis?.[d]?.map((kpi:any, key2:number)=>{
                                        //     let colors = getKPIColors(kpi.level);
                                        //     let is_percentage = 'percentage' in kpi.value
                                        //     let value = is_percentage ? kpi.value.percentage : kpi.value.value
                                        //     return(
                                        //         <td
                                        //             key={key2}
                                        //         >
                                        //             <div className="kpi-history-value">
                                        //                 {value}{is_percentage ? '%' : ''}{" "}
                                        //                 <span
                                        //                     style={{
                                        //                         color: colors ? colors[1] : undefined
                                        //                     }}
                                        //                 >
                                        //                     (Lvl.{kpi.level}) 
                                        //                 </span>
                                        //             </div>
                                        //         </td>
                                        //     )
                                        // })
                                    }
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            </div>
        )
    }

};
